import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
// Utilizar la clase helper
import { Helper } from '../helpers/helper';
import { map } from 'rxjs/operators';


@Injectable()
export class EmpleadosServicio {
  datosEmpleado: any;
  paginasAsignadas: any[];
  permisosAsignados: any[];
  public header: HttpHeaders;
  constructor(private http: HttpClient,
    private helper: Helper) {
    }

  iniciarSesion(datos: any) {
  return this.http.post(`${this.helper.urlServer}/oauth/empleado`, JSON.stringify(datos), { headers: this.helper.getHeader('') });
  }

  verificarTokenSesion() {
    return this.http.get(`${ this.helper.urlServer }/api/v1/verificar-token`,
    { headers: this.helper.getHeader(localStorage.getItem('token')) });
  }

  verificarSuperAdmin() {
    return this.http.post(`${ this.helper.urlServer }/api/v1/verificar-super-usr`, '',
    { headers: this.helper.getHeader(localStorage.getItem('token')) });
  }

  cerrarSesion(datos: any) {
    return this.http.post(`${ this.helper.urlServer }/api/v1/cerrar-sesion`, datos,
    { headers: this.helper.getHeader(localStorage.getItem('token')) });
  }

  cargarActividades() {
    return this.http.get(`${this.helper.urlServer}/api/v1/lista-actividades/${this.datosEmpleado.ID_EMPLEADO}`,
    { headers: this.helper.getHeader(localStorage.getItem('token')) }).map(res => res);
  }

  crearEmpleado(data: any) {
    return this.http.post(`${this.helper.urlServer}/api/v1/registrar-empleado`, data,
    {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  listaEmpleadoRutas(tipo_empleado: string = 'any', ID_RUTA: number = -1) {
    let params = new HttpParams();
    params = params.append('tipo_empleado', tipo_empleado);
    return this.http.get(`${this.helper.urlServer}/api/v1/lista-empleados-rutas/${ID_RUTA}`,
    {headers: this.helper.getHeader(localStorage.getItem('token')), params}).map((res: any) => res);
  }
  listaEmpleado(tipo_empleado: string = 'any', limit?, offset?, busqueda?, estado?) {
    let params = new HttpParams();
    params = params.append('tipo_empleado', tipo_empleado);
    if (limit && !isNaN(limit)) {
      params = params.append('limit', limit);
      params = params.append('offset', offset);
    }
    if (busqueda) {
      params = params.append('busqueda', busqueda);
    }
    if (estado) {
      params = params.append('estado', estado);
    }
    return this.http.get<{ empleados: any[], total_items: number }>(`${this.helper.urlServer}/api/v1/lista-empleados`,
    {headers: this.helper.getHeader(localStorage.getItem('token')), params});
  }

  abrirNotificaciones() {
    return this.http.put(`${this.helper.urlServer}/api/v1/abrir-notificaciones`,
    {ID_EMPLEADO: this.datosEmpleado.ID_EMPLEADO}, { headers: this.helper.getHeader(localStorage.getItem('token')) });
  }

  abrirActividad(actividad: any) {
    return this.http.put(`${this.helper.urlServer}/api/v1/abrir-actividad`,
    {actividad, ID_EMPLEADO: this.datosEmpleado.ID_EMPLEADO}, { headers: this.helper.getHeader(localStorage.getItem('token')) });
  }

  cargarEmpleadoPorId(id) {
    return this.http.get(`${this.helper.urlServer}/api/v1/perfil-empleado/${id}`,
    {headers: this.helper.getHeader(localStorage.getItem('token'))}).map((res: any) => res);
  }

  editarPass(data) {
    return this.http.put(`${this.helper.urlServer}/api/v1/editar-contrasena`, data,
    {headers: this.helper.getHeader(localStorage.getItem('token'))})
    .map((res: any) => res);
  }

  obtenerUsuario(nombre: string, apellido: string) {
    let params = new HttpParams();
    params = params.append('nombre', nombre);
    params = params.append('apellido', apellido);
    return this.http.get(`${this.helper.urlServer}/api/v1/obtener-usuario`,
    {headers: this.helper.getHeader(localStorage.getItem('token')), params}).map((res: any) => res);
  }

  empleadosPorRutasAsignadas(ID_RUTA, tipo_empleado = '2') {
    let params = new HttpParams();
    params = params.append('ruta', ID_RUTA);
    params = params.append('tipo_empleado', tipo_empleado);
    return this.http.get(`${this.helper.urlServer}/api/v1/empleados-por-rutas`,
    {headers: this.helper.getHeader(localStorage.getItem('token')), params}).map((res: any) => res);
  }

  cargarRecordatorios() {
    let params = new HttpParams();
    if (this.datosEmpleado.tipo_empleado === 1) {
      params = params.append('empleado', this.datosEmpleado.ID_EMPLEADO);
    }
    return this.http.get(`${this.helper.urlServer}/api/v1/lista-recordatorios`,
    { headers: this.helper.getHeader(localStorage.getItem('token')), params }).map(res => res);
  }

  completarRecordatorios(data) {
    return this.http.put(`${this.helper.urlServer}/api/v1/completar-recordatorios`, data,
    {headers: this.helper.getHeader(localStorage.getItem('token'))})
    .map((res: any) => res);
  }

  ruterosMapa() {
    return this.http.get(`${this.helper.urlServer}/api/v1/ruteros-mapa`,
    { headers: this.helper.getHeader(localStorage.getItem('token')) }).map(res => res);
  }

  activarDesactivarEmpleado(data) {
    return this.http.put(`${this.helper.urlServer}/api/v1/activar_desactivar_empleado`, data,
    { headers: this.helper.getHeader(localStorage.getItem('token')) })
    .map((res: any) => res);
  }

  restablecerPassword(data: any) {
    return this.http.post(`${this.helper.urlServer}/api/v1/password-reset`, data, { headers: this.helper.getHeader(localStorage.getItem('token')) });
  }

  prestamosPendiente() {
    let params = new HttpParams();
    if (this.datosEmpleado.tipo_empleado === 1) {
      params = params.append('empleado', this.datosEmpleado.ID_EMPLEADO);
    }
    return this.http.get(`${this.helper.urlServer}/api/v1/prestamos_pendientes`,
    { headers: this.helper.getHeader(localStorage.getItem('token')), params }).map(res => res);
  }

  obtenerPreguntasSecretas() {
    // tslint:disable-next-line:max-line-length
    return this.http.get(`${this.helper.urlServer}/api/v1/preguntas_secretas`, { headers: this.helper.getHeader(localStorage.getItem('token')) });
  }

  guardarRespuestasPgSecret(data: any) {
    // tslint:disable-next-line:max-line-length
    return this.http.post(`${this.helper.urlServer}/api/v1/guardar-respuestas-preguntas-secretas`, data,  { headers: this.helper.getHeader(localStorage.getItem('token')) })
    .map((res: any) => res);
  }

  ruteros() {
    return this.http.get(`${this.helper.urlServer}/api/v1/lista-ruteros-con-rutas`,
    {headers: this.helper.getHeader(localStorage.getItem('token'))}).map((res: any) => res);
  }

  empleadoActividades() {
    return this.http.get(`${this.helper.urlServer}/api/v1/empleados-actividades`,
    {headers: this.helper.getHeader(localStorage.getItem('token'))}).map((res: any) => res);
  }

  editarEmpleado(data: any) {
    return this.http.put(`${this.helper.urlServer}/api/v1/editar-empleado`, data,
    {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  preSolicitudesPendiente() {
    return this.http.get(`${this.helper.urlServer}/api/v1/pre-solicitudes_pendientes`,
    { headers: this.helper.getHeader(localStorage.getItem('token')) }).map(res => res);
  }

  asignarSolicitud(data: any) {
    return this.http.put(`${this.helper.urlServer}/api/v1/asignar-solicitud-prestamo`, data,
    {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  tokenCode(ID_EMPLEADO: number) {
    return this.http.get<string>(`${ this.helper.urlServer }/api/v1/token-code/${ID_EMPLEADO}`,
    { headers: this.helper.getHeader(localStorage.getItem('token')) });
  }

  verificartokenPass(email: string, token: string) {
    return this.http.get<number>(`${ this.helper.urlServer }/api/v1/verificar-pass-reset-token/${email}/${token}`,
    { headers: this.helper.getHeader(localStorage.getItem('token')) });
  }

  nuevaContrasena(data) {
    return this.http.put(`${this.helper.urlServer}/api/v1/nueva-contrasena`, data,
    {headers: this.helper.getHeader(localStorage.getItem('token'))})
    .map((res: any) => res);
  }

  descargarBackup(tipo = 'db') {
    let params = new HttpParams();
    params = params.append('tipo', tipo);
    return this.http.get<string>(`${this.helper.urlServer}/api/v1/backup`,
    { params, headers: this.helper.getHeader(localStorage.getItem('token'))})
    .pipe(
      map(result => `${this.helper.urlServer}/${result}`)
    );
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/services/empleado.service.ts